import { styled, Typography, TypographyProps } from '@mui/material';
import { FC } from 'react';

const Heading: FC<TypographyProps> = ({ children, ...props }) => {
    return (
        <StyledContainerHeading variant="subtitle2" {...props}>
            {children}
        </StyledContainerHeading>
    );
};

const StyledContainerHeading = styled(Typography)({
    fontSize: 20,
});

export default Heading;
